import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { IsActiveMatchOptions, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { AvanoMenuExpander, SelfExpandableAvanoMenu } from './avano-menu-expander';
import { AvanoMenuEntry } from './avano-menu.common';

/**
 * TODO:
 * - Scrollable menuitems works, but the styling is not correct (shadow, divider top bottom)
 * -- Library needs to be added?
 * -- Be aware of element height changes AND window.resize-events
 * -- perhaps can use: https://www.npmjs.com/package/css-element-queries
 *
 * To be able to support level 3 following needs to be done:
 * - Menuitems group level 2
 * - Menuitems level 3
 * - collapsed: hover submenu level 3
 * - collapsed: hover submenu group level 2
 *
 * - Font-sizes and paddings are not 100% like the styleguide
 * - Animations are missing
 *
 * - On overlay menu (second level) the extra area for the mouse to not disappear is missing (collapsed mode)
 */
@Component({
  selector: 'avano-menu',
  templateUrl: './avano-menu.component.html',
  styleUrls: ['./avano-menu.component.scss']
})
export class AvanoMenuComponent implements OnDestroy, SelfExpandableAvanoMenu {
  @Input() menuTitle: string;
  @Input() appVersion: string;

  private _menuEntries: AvanoMenuEntry[] = [];
  @Input() set menuEntries(newMenuEntries: AvanoMenuEntry[]) {
    if (newMenuEntries !== this._menuEntries) {
      this._menuEntries = newMenuEntries;
      this.menuExpander.expandMenuItemsForUrl(this.router.url);
    }
  }
  get menuEntries(): AvanoMenuEntry[] {
    return this._menuEntries;
  }

  @Input() set expandOnNavigation(expand: boolean) {
    this.expandOnNavigation$.next(expand);
  }

  private _collapsed: boolean;
  @Input()
  get collapsed(): boolean { return this._collapsed; }
  set collapsed(newState: boolean) { if (this._collapsed !== newState) { this._collapsed = newState; this.collapsedChange.emit(newState)}}
  @Output() collapsedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  expandOnNavigation$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  destroyed$: Subject<void> = new Subject<void>();

  routerLinkActiveOptions: IsActiveMatchOptions = {
    fragment: 'ignored',
    matrixParams: 'ignored',
    paths: 'exact',
    queryParams: 'ignored'
  };

  private menuExpander = new AvanoMenuExpander(this);

  constructor(public router: Router) {
    this.menuExpander.initExpandOnNavigationFeature();
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  toggleMenu() {
    this.collapsed = !this.collapsed;
  }

  toggleGroup(menuEntry: AvanoMenuEntry) {
    menuEntry.isExpanded = !menuEntry.isExpanded;
  }
}
